
<template>
  <div class="admin-orders">
    <!-- 引入编辑组件但不显示，仅用于调用方法 -->
    <OrderEditComponent ref="orderEditComponentRef" :is-mobile="isMobile" @update="fetchOrders" @cancel="() => {}"/>
    <BulkOrderEditComponent ref="bulkOrderEditComponentRef" :is-mobile="isMobile" @update="fetchBulkOrders" @cancel="() => {}"/>
    <FuxiangsanOrderEditComponent ref="fuxiangsanOrderEditComponentRef" :is-mobile="isMobile" @update="fetchFuxiangsanOrders" @cancel="() => {}"/>
    
    <div class="filter-section" style="margin-bottom: 20px;">
      <el-select v-model="selectedStatus" placeholder="选择订单状态" clearable style="width: 150px;">
        <el-option label="全部订单" value=""></el-option>
        <el-option label="已导出" value="Exported"></el-option>
        <el-option label="未导出" value="Noexported"></el-option>
      </el-select>
      <el-date-picker
          v-model="selectedDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="YYYY-MM-DD"
          style="padding: 0;"
          class="date-picker-mobile"
      />
      <!-- 超主点订单查询条件，仅在超主点订单标签页显示 -->
      <template v-if="activeTab === 'regular'">
        <el-input v-model="selectedPatientName" placeholder="患者姓名" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedCompany" placeholder="验配单位" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedLensModel" placeholder="订单型号" clearable style="width: 150px;"></el-input>
      </template>
      <!-- 其他订单查询条件，仅在赋像散订单标签页显示 -->
      <template v-if="activeTab === 'fuxiangsanOrder'">
        <el-input v-model="selectedPatientName" placeholder="患者姓名" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedCompany" placeholder="验配单位" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedLensModel" placeholder="订单型号" clearable style="width: 150px;"></el-input>
      </template>
      <!-- 批量订单查询条件，仅在批量订单标签页显示 -->
      <template v-if="activeTab === 'bulk'">
        <el-input v-model="selectedCompany" placeholder="验配单位" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedLensModel" placeholder="订单型号" clearable style="width: 150px;"></el-input>
      </template>
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="resetSearch" style="margin-left: 0">重置</el-button>
    </div>

    <div class="content">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="超主点订单" name="regular">
          <el-card>
            <template #header>
              <span>超主点订单管理</span>
              <div style="float: right;">
                <el-button
                    type="primary"
                    size="small"
                    @click="handleExportExcel"
                    style="margin-right: 10px;">
                  导出未导出订单
                </el-button>
                <el-button
                    type="success"
                    size="small"
                    @click="handleExportSelectedOrders"
                    :disabled="selectedRegularOrderRows.length === 0">
                  导出选中订单
                </el-button>
              </div>
            </template>
            <!-- PC端表格视图 -->
            <div class="table-container" v-if="!isMobile">
              <el-table 
                  :data="filteredOrders" 
                  style="width: 100%" 
                  border
                  @selection-change="handleRegularSelectionChange">
                <!-- 选择列 -->
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <!-- 基本信息 -->
                <el-table-column label="序号" width="100" fixed="left">
                  <template #default="scope">
                    <!-- 从1开始计算序号，并考虑分页偏移 -->
                    {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
                  </template>
                </el-table-column>
                <el-table-column prop="orderType" label="订单类型" width="150"></el-table-column>
                <el-table-column prop="orderNumber" label="订单号" width="200"></el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                  <template #default="scope">
                    <el-tag :type="getStatusType(scope.row.status)">
                      {{ getStatusText(scope.row.status) }}
                    </el-tag>
                  </template>
                </el-table-column>


                <!-- 订单基本信息 -->
                <el-table-column label="订单基本信息" align="center">
                  <el-table-column prop="orderDate" label="订单日期" width="120"></el-table-column>
                  <el-table-column prop="lensModel" label="订单型号" width="120"></el-table-column>
                  <el-table-column prop="company" label="验配单位" width="120"></el-table-column>
                  <el-table-column prop="purchasingUnits" label="采购单位" width="120"></el-table-column>
                  <el-table-column prop="patientName" label="患者姓名" width="100"></el-table-column>
                  <el-table-column prop="age" label="年龄" width="80"></el-table-column>
                  <el-table-column prop="optometrist" label="验光师" width="100"></el-table-column>
                  <el-table-column prop="region" label="地区" width="100"></el-table-column>
                </el-table-column>

                <!-- 常规验光数据 -->
                <el-table-column label="常规验光" align="center">
                  <el-table-column label="右眼" align="center">
                    <el-table-column label="球镜" width="80">
                      <template #default="scope">
                        {{ scope.row.regularOdSphere > 0 ? '+' + scope.row.regularOdSphere : scope.row.regularOdSphere }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="regularOdCylinder" label="柱镜" width="80"></el-table-column>
                    <el-table-column prop="regularOdAxis" label="轴位" width="80"></el-table-column>
                    <el-table-column prop="regularOdVision" label="视力" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column label="左眼" align="center">
                    <el-table-column label="球镜" width="80">
                      <template #default="scope">
                        {{ scope.row.regularOsSphere > 0 ? '+' + scope.row.regularOsSphere : scope.row.regularOsSphere }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="regularOsCylinder" label="柱镜" width="80"></el-table-column>
                    <el-table-column prop="regularOsAxis" label="轴位" width="80"></el-table-column>
                    <el-table-column prop="regularOsVision" label="视力" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column prop="regularBinocularFusion" label="双眼融像" width="120"></el-table-column>
                  <el-table-column prop="regularStereoscopicVisionFunction" label="立体视功能" width="120"></el-table-column>
                  <el-table-column prop="regularBinocularVision" label="双眼视力" width="100"></el-table-column>
                </el-table-column>

                <!-- 超主点验光数据 -->
                <el-table-column label="超主点验光" align="center">
                  <el-table-column label="右眼" align="center">
                    <el-table-column label="球镜" width="80">
                      <template #default="scope">
                        {{ scope.row.superOdSphere > 0 ? '+' + scope.row.superOdSphere : scope.row.superOdSphere }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="superOdCylinder" label="柱镜" width="80"></el-table-column>
                    <el-table-column prop="superOdAxis" label="轴位" width="80"></el-table-column>
                    <el-table-column prop="superOdVision" label="视力" width="80"></el-table-column>
                    <el-table-column prop="odQuantity" label="数量" width="100"></el-table-column>
                  </el-table-column>
                  <el-table-column label="左眼" align="center">
                    <el-table-column label="球镜" width="80">
                      <template #default="scope">
                        {{ scope.row.superOsSphere > 0 ? '+' + scope.row.superOsSphere : scope.row.superOsSphere }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="superOsCylinder" label="柱镜" width="80"></el-table-column>
                    <el-table-column prop="superOsAxis" label="轴位" width="80"></el-table-column>
                    <el-table-column prop="superOsVision" label="视力" width="80"></el-table-column>
                    <el-table-column prop="osQuantity" label="数量" width="100"></el-table-column>
                  </el-table-column>
                  <el-table-column prop="superBinocularFusion" label="双眼融像" width="120"></el-table-column>
                  <el-table-column prop="superStereoscopicVisionFunction" label="立体视功能" width="120"></el-table-column>
                  <el-table-column prop="superBinocularVision" label="双眼视力" width="100"></el-table-column>
                </el-table-column>

                <!-- 角膜曲率 -->
                <el-table-column label="角膜曲率" align="center">
                  <el-table-column label="右眼" align="center">
                    <el-table-column prop="odK1" label="K1" width="80"></el-table-column>
                    <el-table-column prop="odK2" label="K2" width="80"></el-table-column>
                    <el-table-column prop="odAxialLength" label="眼轴" width="80"></el-table-column>
                    <el-table-column prop="odChoroidalThickness" label="脉络膜厚度" width="100"></el-table-column>
                  </el-table-column>
                  <el-table-column label="左眼" align="center">
                    <el-table-column prop="osK1" label="K1" width="80"></el-table-column>
                    <el-table-column prop="osK2" label="K2" width="80"></el-table-column>
                    <el-table-column prop="osAxialLength" label="眼轴" width="80"></el-table-column>
                    <el-table-column prop="osChoroidalThickness" label="脉络膜厚度" width="100"></el-table-column>
                  </el-table-column>
                </el-table-column>

                <!-- 眼镜参数 -->
                <el-table-column label="眼镜参数" align="center">
                  <el-table-column label="右眼" align="center">
                    <el-table-column prop="odPupilHeight" label="瞳高" width="80"></el-table-column>
                    <el-table-column prop="odPupilDistance" label="瞳距" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column label="左眼" align="center">
                    <el-table-column prop="osPupilHeight" label="瞳高" width="80"></el-table-column>
                    <el-table-column prop="osPupilDistance" label="瞳距" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column prop="binocularPupilDistance" label="双眼瞳距" width="100"></el-table-column>
                  <el-table-column prop="frameNumber" label="镜框编号" width="100"></el-table-column>
                </el-table-column>

                <!-- 邮寄信息 -->
                <el-table-column prop="addressee" label="收件人" width="150"></el-table-column>
                <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
                <el-table-column prop="shippingAddress" label="邮寄地址" width="200"></el-table-column>
                <el-table-column prop="trackingNumber" label="物流编号" width="200"></el-table-column>
                <el-table-column prop="deliveryDate" label="邮寄日期" width="150"></el-table-column>
                <el-table-column prop="remarks" label="备注" width="200"></el-table-column>

                <el-table-column prop="createdAt" label="创建时间" width="180"></el-table-column>
                <el-table-column prop="updatedAt" label="更新时间" width="180"></el-table-column>

                <!-- 操作列 -->
                <el-table-column label="操作" width="250" fixed="right">
                  <template #default="scope">
                    <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                    <el-button size="small" type="info" @click="checkTracking(scope.row)" v-if="scope.row.trackingNumber">查询物流</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            
            <!-- 修改移动端卡片视图的结构 -->
            <!-- 移动端卡片视图 -->
            <div class="mobile-cards-container" v-else>
              <OrderMobileCard
                v-for="(item, index) in filteredOrders"
                :key="item.id"
                :item="item"
                :index="index"
                :current-page="currentPage"
                :page-size="pageSize"
                order-type="regular"
                @select="(event) => handleItemSelect(event.item, 'regular', event.selected)"
                @edit="handleEdit"
                @delete="handleDelete"
                @details="showOrderDetails"
                @check-tracking="checkTracking"
              />
              
              <!-- 没有数据时显示 -->
              <el-empty v-if="filteredOrders.length === 0" description="没有找到订单数据"></el-empty>
            </div>
            
            <!-- 分页 -->
            <div class="pagination-wrapper">
              <el-pagination
                  @size-change="handleRegularSizeChange"
                  @current-change="handleRegularCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  :pager-count="isMobile ? 3 : 7"
                  layout="total, sizes, -> , prev, pager, next, jumper"
                  :total="totalItems"
                  background
              >
              </el-pagination>
            </div>
          </el-card>
        </el-tab-pane>
        
        <el-tab-pane label="其他订单" name="fuxiangsanOrder">
          <el-card>
            <template #header>
              <span>其他订单管理</span>
              <div style="float: right;">
                <el-button
                    type="primary"
                    size="small"
                    @click="handleExportFuxiangsanExcel"
                    style="margin-right: 10px;">
                  导出未导出订单
                </el-button>
                <el-button
                    type="success"
                    size="small"
                    @click="handleExportSelectedFuxiangsanOrders"
                    :disabled="selectedFuxiangsanOrderRows.length === 0">
                  导出选中订单
                </el-button>
              </div>
            </template>
            <!-- PC端表格视图 -->
            <div class="table-container" v-if="!isMobile">
              <el-table 
                  :data="filteredFuxiangsanOrders" 
                  style="width: 100%" 
                  border
                  @selection-change="handleFuxiangsanSelectionChange">
                <!-- 选择列 -->
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <!-- 基本信息 -->
                <el-table-column label="序号" width="100" fixed="left">
                  <template #default="scope">
                    <!-- 从1开始计算序号，并考虑分页偏移 -->
                    {{ scope.$index + 1 + (fuxiangsanCurrentPage - 1) * fuxiangsanPageSize }}
                  </template>
                </el-table-column>
                <el-table-column prop="orderType" label="订单类型" width="150"></el-table-column>
                <el-table-column prop="orderNumber" label="订单号" width="200"></el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                  <template #default="scope">
                    <el-tag :type="getStatusType(scope.row.status)">
                      {{ getStatusText(scope.row.status) }}
                    </el-tag>
                  </template>
                </el-table-column>

                <!-- 订单基本信息 -->
                <el-table-column label="订单基本信息" align="center">
                  <el-table-column prop="orderDate" label="订单日期" width="120"></el-table-column>
                  <el-table-column prop="lensModel" label="订单型号" width="120"></el-table-column>
                  <el-table-column prop="company" label="验配单位" width="120"></el-table-column>
                  <el-table-column prop="purchasingUnits" label="采购单位" width="120"></el-table-column>
                  <el-table-column prop="patientName" label="患者姓名" width="100"></el-table-column>
                  <el-table-column prop="age" label="年龄" width="80"></el-table-column>
                  <el-table-column prop="optometrist" label="验光师" width="100"></el-table-column>
                  <el-table-column prop="region" label="地区" width="100"></el-table-column>
                </el-table-column>

                <!-- 常规验光数据 -->
                <el-table-column label="常规验光" align="center">
                  <el-table-column label="右眼" align="center">
                    <el-table-column label="球镜" width="80">
                      <template #default="scope">
                        {{ scope.row.regularOdSphere > 0 ? '+' + scope.row.regularOdSphere : scope.row.regularOdSphere }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="regularOdCylinder" label="柱镜" width="80"></el-table-column>
                    <el-table-column prop="regularOdAxis" label="轴位" width="80"></el-table-column>
                    <el-table-column prop="regularOdVision" label="视力" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column label="左眼" align="center">
                    <el-table-column label="球镜" width="80">
                      <template #default="scope">
                        {{ scope.row.regularOsSphere > 0 ? '+' + scope.row.regularOsSphere : scope.row.regularOsSphere }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="regularOsCylinder" label="柱镜" width="80"></el-table-column>
                    <el-table-column prop="regularOsAxis" label="轴位" width="80"></el-table-column>
                    <el-table-column prop="regularOsVision" label="视力" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column prop="regularBinocularVision" label="双眼视力" width="100"></el-table-column>
                </el-table-column>

                <!-- 赋像散验光数据 -->
                <el-table-column label="赋像散验光" align="center">
                  <el-table-column label="右眼" align="center">
                    <el-table-column label="球镜" width="80">
                      <template #default="scope">
                        {{ scope.row.superOdSphere > 0 ? '+' + scope.row.superOdSphere : scope.row.superOdSphere }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="superOdCylinder" label="柱镜" width="80"></el-table-column>
                    <el-table-column prop="superOdAxis" label="轴位" width="80"></el-table-column>
                    <el-table-column prop="superOdVision" label="视力" width="80"></el-table-column>
                    <el-table-column prop="odQuantity" label="数量" width="100"></el-table-column>
                  </el-table-column>
                  <el-table-column label="左眼" align="center">
                    <el-table-column label="球镜" width="80">
                      <template #default="scope">
                        {{ scope.row.superOsSphere > 0 ? '+' + scope.row.superOsSphere : scope.row.superOsSphere }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="superOsCylinder" label="柱镜" width="80"></el-table-column>
                    <el-table-column prop="superOsAxis" label="轴位" width="80"></el-table-column>
                    <el-table-column prop="superOsVision" label="视力" width="80"></el-table-column>
                    <el-table-column prop="osQuantity" label="数量" width="100"></el-table-column>
                  </el-table-column>
                  <el-table-column prop="superBinocularVision" label="双眼视力" width="100"></el-table-column>
                </el-table-column>

                <!-- 角膜曲率 -->
                <el-table-column label="角膜曲率" align="center">
                  <el-table-column label="右眼" align="center">
                    <el-table-column prop="odK1" label="K1" width="80"></el-table-column>
                    <el-table-column prop="odK2" label="K2" width="80"></el-table-column>
                    <el-table-column prop="odAxialLength" label="眼轴" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column label="左眼" align="center">
                    <el-table-column prop="osK1" label="K1" width="80"></el-table-column>
                    <el-table-column prop="osK2" label="K2" width="80"></el-table-column>
                    <el-table-column prop="osAxialLength" label="眼轴" width="80"></el-table-column>
                  </el-table-column>
                </el-table-column>

                <!-- 眼镜参数 -->
                <el-table-column label="眼镜参数" align="center">
                  <el-table-column label="右眼" align="center">
                    <el-table-column prop="odPupilHeight" label="瞳高" width="80"></el-table-column>
                    <el-table-column prop="odPupilDistance" label="瞳距" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column label="左眼" align="center">
                    <el-table-column prop="osPupilHeight" label="瞳高" width="80"></el-table-column>
                    <el-table-column prop="osPupilDistance" label="瞳距" width="80"></el-table-column>
                  </el-table-column>
                  <el-table-column prop="binocularPupilDistance" label="双眼瞳距" width="100"></el-table-column>
                  <el-table-column prop="frameNumber" label="镜框编号" width="100"></el-table-column>
                </el-table-column>
                <!--眼位-->
                <el-table-column label="眼位" align="center">
                  <el-table-column prop="eyePositionFar" label="眼位(远)" width="80"></el-table-column>
                  <el-table-column prop="eyePositionNear" label="眼位(近)" width="80"></el-table-column>
                </el-table-column>



                  <!-- 邮寄信息 -->
                <el-table-column prop="addressee" label="收件人" width="150"></el-table-column>
                <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
                <el-table-column prop="shippingAddress" label="邮寄地址" width="200"></el-table-column>
                <el-table-column prop="trackingNumber" label="物流编号" width="200"></el-table-column>
                <el-table-column prop="deliveryDate" label="邮寄日期" width="150"></el-table-column>
                <el-table-column prop="remarks" label="备注" width="200"></el-table-column>

                <el-table-column prop="createdAt" label="创建时间" width="180"></el-table-column>
                <el-table-column prop="updatedAt" label="更新时间" width="180"></el-table-column>

                <!-- 操作列 -->
                <el-table-column label="操作" width="250" fixed="right">
                  <template #default="scope">
                    <el-button size="small" @click="handleEditFuxiangsan(scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="handleDeleteFuxiangsan(scope.row)">删除</el-button>
                    <el-button size="small" type="info" @click="checkTracking(scope.row)" v-if="scope.row.trackingNumber">查询物流</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            
            <!-- 赋像散订单的移动端卡片视图 -->
            <div class="mobile-cards-container" v-else>
              <OrderMobileCard
                v-for="(item, index) in filteredFuxiangsanOrders"
                :key="item.id"
                :item="item"
                :index="index"
                :current-page="fuxiangsanCurrentPage"
                :page-size="fuxiangsanPageSize"
                order-type="fuxiangsan"
                @select="(event) => handleItemSelect(event.item, 'fuxiangsan', event.selected)"
                @edit="handleEditFuxiangsan"
                @delete="handleDeleteFuxiangsan"
                @details="showFuxiangsanOrderDetails"
                @check-tracking="checkTracking"
              />
              
              <!-- 没有数据时显示 -->
              <el-empty v-if="filteredFuxiangsanOrders.length === 0" description="没有找到订单数据"></el-empty>
            </div>
            
            <!-- 分页 -->
            <div class="pagination-wrapper">
              <el-pagination
                  @size-change="handleFuxiangsanSizeChange"
                  @current-change="handleFuxiangsanCurrentChange"
                  :current-page="fuxiangsanCurrentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="fuxiangsanPageSize"
                  :pager-count="isMobile ? 3 : 7"
                  layout="total, sizes, -> , prev, pager, next, jumper"
                  :total="fuxiangsanTotalItems"
                  background
              >
              </el-pagination>
            </div>
          </el-card>
        </el-tab-pane>
        
        <el-tab-pane label="批量订单" name="bulk">
          <el-card>
            <template #header>
              <span>批量订单管理</span>
              <div style="float: right;">
                <el-button
                    type="primary"
                    size="small"
                    @click="handleExportBulkExcel"
                    style="margin-right: 10px;">
                  导出未导出订单
                </el-button>
                <el-button
                    type="success"
                    size="small"
                    @click="handleExportSelectedBulkOrders"
                    :disabled="selectedBulkOrderRows.length === 0">
                  导出选中订单
                </el-button>
              </div>
            </template>
            <!-- PC端表格视图 -->
            <div class="table-container" v-if="!isMobile">
              <el-table 
                  :data="filteredBulkOrders" 
                  style="width: 100%" 
                  border
                  @selection-change="handleBulkSelectionChange">
                <!-- 选择列 -->
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <!-- 基本信息 -->
                <el-table-column label="序号" width="100" fixed="left">
                  <template #default="scope">
                    <!-- 从1开始计算序号，并考虑分页偏移 -->
                    {{ scope.$index + 1 + (bulkCurrentPage - 1) * bulkPageSize }}
                  </template>
                </el-table-column>
                <el-table-column prop="orderType" label="订单类型" width="150"></el-table-column>
                <el-table-column prop="orderNumber" label="订单号" width="200"></el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                  <template #default="scope">
                    <el-tag :type="getStatusType(scope.row.status)">
                      {{ getStatusText(scope.row.status) }}
                    </el-tag>
                  </template>
                </el-table-column>


                <!-- 订单基本信息 -->
                <el-table-column label="订单基本信息" align="center">
                  <el-table-column prop="orderDate" label="订单日期" width="120"></el-table-column>
                  <el-table-column prop="company" label="验配单位" width="120"></el-table-column>
                  <el-table-column prop="purchasingUnits" label="采购单位" width="120"></el-table-column>
                  <el-table-column prop="lensModel" label="订单型号" width="120"></el-table-column>
                  <el-table-column prop="region" label="地区" width="100"></el-table-column>
                  <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
                </el-table-column>

                <!-- 邮寄信息 -->
                <el-table-column prop="addressee" label="收件人" width="150"></el-table-column>
                <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
                <el-table-column prop="shippingAddress" label="邮寄地址" width="200"></el-table-column>
                <el-table-column prop="trackingNumber" label="物流编号" width="200"></el-table-column>
                <el-table-column prop="deliveryDate" label="邮寄日期" width="150"></el-table-column>
                <el-table-column prop="remarks" label="备注" width="200"></el-table-column>

                <el-table-column prop="createdAt" label="创建时间" width="180"></el-table-column>
                <el-table-column prop="updatedAt" label="更新时间" width="180"></el-table-column>

                <!-- 操作列 -->
                <el-table-column label="操作" width="250" fixed="right">
                  <template #default="scope">
                    <el-button size="small" @click="handleEditBulk(scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="handleDeleteBulk(scope.row)">删除</el-button>
                    <el-button size="small" type="info" @click="checkTracking(scope.row)" v-if="scope.row.trackingNumber">查询物流</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            
            <!-- 批量订单的移动端卡片视图 -->
            <div class="mobile-cards-container" v-else>
              <OrderMobileCard
                v-for="(item, index) in filteredBulkOrders"
                :key="item.id"
                :item="item"
                :index="index"
                :current-page="bulkCurrentPage"
                :page-size="bulkPageSize"
                order-type="bulk"
                @select="(event) => handleItemSelect(event.item, 'bulk', event.selected)"
                @edit="handleEditBulk"
                @delete="handleDeleteBulk"
                @details="showBulkOrderDetails"
                @check-tracking="checkTracking"
              />
              
              <!-- 没有数据时显示 -->
              <el-empty v-if="filteredBulkOrders.length === 0" description="没有找到订单数据"></el-empty>
            </div>
            
            <!-- 分页 -->
            <div class="pagination-wrapper">
              <el-pagination
                  @size-change="handleBulkSizeChange"
                  @current-change="handleBulkCurrentChange"
                  :current-page="bulkCurrentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="bulkPageSize"
                  :pager-count="isMobile ? 3 : 7"
                  layout="total, sizes, -> , prev, pager, next, jumper"
                  :total="bulkTotalItems"
                  background
              >
              </el-pagination>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<!-- 添加移动端卡片样式 -->
<style scoped>
.admin-orders {
  width: 100%;
}

.content {
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
}

.filter-section {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}


.table-container {
  overflow-x: auto;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  /* 确保移动端可以横向滚动 */
  -webkit-overflow-scrolling: touch;
}

/* 添加表格单元格样式，确保内容不换行且超出显示省略号 */
:deep(.el-table .cell) {
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 超出部分隐藏 */
  text-overflow: ellipsis;  /* 超出部分显示省略号 */
}

/* PC端操作列按钮样式 */
.el-table .el-button {
  margin: 0 3px;
  padding: 7px 10px;
  font-size: 12px;
}

/* 确保PC端操作列按钮在同一行 */
.el-table .el-table__fixed-right .el-table-column--right .cell {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;
}

/* 表格头部固定样式 */
.el-table--border th.el-table__cell.is-leaf {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #f5f7fa;
}

/* 移动端卡片样式 */
.mobile-cards-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px 0;
}

.card-actions .el-button {
  margin: 0;
}

@media screen and (max-width: 768px) {
  .filter-section {
    flex-direction: column;
    align-items: stretch;
    padding: 10px;
  }
  
  .filter-section > * {
    width: 100% !important;
    margin-bottom: 10px;
  }
  
  ::v-deep .custom-date-picker .el-input__inner {
    width: 100%; /* 移动端日期选择器宽度调整 */
  }
  
  /* 表格适配移动端 */
  .table-container {
    max-height: calc(100vh - 180px);
  }
  
  /* 移动端表格按钮样式调整 */
  .el-table .el-button {
    padding: 8px 12px;
    margin-bottom: 5px;
    display: block;
    width: 100%;
    font-size: 13px;
  }
  
  .el-card__header .el-button {
    margin-bottom: 5px;
    font-size: 13px;
    padding: 8px 10px;
  }
  
  .el-card__header div[style="float: right;"] {
    float: none !important;
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
  }
  
  .el-card__header div[style="float: right;"] .el-button {
    flex: 1;
    margin-right: 5px;
    white-space: nowrap;
  }

  .el-card__header span {
    display: block;
    margin-bottom: 0;
  }

  /* 移动端日期选择器样式适配 */
  .date-picker-mobile {
    width: 100%;
  }
}

/* 优化移动端表单弹窗样式 */
:deep(.el-message-box) {
  width: 95% !important;
  max-width: 95% !important;
}

:deep(.el-message-box__headerbtn) {
  padding: 15px;
}

:deep(.el-message-box__content) {
  padding: 10px;
  max-height: 70vh;
  overflow-y: auto;
}

/* 订单详情弹窗样式优化 */
:deep(.details-dialog) {
  width: 95% !important;
  max-width: 800px !important;
}

:deep(.details-dialog .el-message-box__content) {
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px 15px;
}
:deep(.el-pagination__rightwrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

/* 移动端卡片视图的额外优化 */
@media screen and (max-width: 768px) {
  .mobile-cards-container {
    padding: 10px 0;
  }


  .order-card .el-card__header {
    background-color: #f9fafc;
    padding: 12px 15px;
    border-bottom: 1px solid #ebeef5;
  }

  .card-actions .el-button {
    margin: 0;
    font-size: 12px;
    padding: 8px 0;
  }

  .el-pagination .el-pagination__total,
  .el-pagination .el-pagination__sizes {
    margin-bottom: 10px;
  }
}

/* 在<style scoped>底部新增分页器样式 */

/* 分页器容器样式 */
.pagination-wrapper {
  margin-top: 20px;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
}

/* 分页器组件样式调整 */
:deep(.el-pagination) {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
}

/* 总条数和每页条数样式 */
:deep(.el-pagination__total),
:deep(.el-pagination__sizes) {
  margin-right: 10px;
}

/* 页码样式 */
:deep(.el-pager) {
  padding: 0;
  margin: 0 5px;
}

:deep(.el-pager li) {
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 2px;
  margin: 0 2px;
  font-weight: normal;
}

/* 当前页码样式 */
:deep(.el-pager li.active) {
  background-color: #409EFF;
  color: white;
  font-weight: bold;
}

/* 前后页按钮样式 */
:deep(.btn-prev),
:deep(.btn-next) {
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  margin: 0 3px;
  padding: 0;
  border-radius: 2px;
}

/* 跳转框样式 */
:deep(.el-pagination__jump) {
  margin-left: 10px;
}

:deep(.el-pagination__editor.el-input) {
  width: 50px;
  margin: 0 5px;
}


/* 移动端分页器特殊处理 */
@media screen and (max-width: 768px) {
  /* 修改分页容器样式 */
  .pagination-wrapper {
    width: 100%;
    padding: 10px 5px;
  }

  /* 分页组件整体布局 - 保持水平布局 */
  :deep(.el-pagination) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  /* 第一行：总条数和每页大小 */
  :deep(.el-pagination__total),
  :deep(.el-pagination__sizes) {
    flex: 1 1 100%;
    text-align: center;
    margin-bottom: 8px;
  }

  /* 页码导航区域 - 与前后页按钮在同一行 */
  :deep(.el-pagination__rightwrapper) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap; /* 允许折行，上一页/页码/下一页一行，跳转可换行 */
    gap: 3px;
  }

  /* 前后页按钮样式调整 */
  :deep(.btn-prev),
  :deep(.btn-next) {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    margin: 0 2px;
    padding: 0;
    border-radius: 2px;
  }

  /* 页码按钮样式调整 */
  :deep(.el-pager li) {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    border-radius: 2px;
    margin: 0 1px;
    font-weight: normal;
  }

  /* 跳转功能单独一行 */
  :deep(.el-pagination__jump) {
    flex: 1 1 100%;
    margin-top: 8px;
    display: flex;
    justify-content: center;
    width: 100%;
  }
}

/* 以下全局样式会添加到document.head中 */
:global(.el-picker-panel) {
  max-width: 100%;
}

:global(.el-date-picker.el-popper[role=tooltip]) {
  width: auto !important;
  min-width: 0 !important;
}
</style>

<script setup>
import { ref, onMounted, computed, } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import axios from 'axios';
// 引入移动端适配工具
import { useMobileDetection } from '@/utils/mobileAdapter';
import OrderMobileCard from '../components/OrderMobileCard.vue';
// 引入新抽离的组件
import OrderEditComponent from '../components/OrderEditComponent.vue';
import BulkOrderEditComponent from '../components/BulkOrderEditComponent.vue';
import FuxiangsanOrderEditComponent from '../components/FuxiangsanOrderEditComponent.vue';
// 引入移动端适配样式
import '../assets/styles/mobile-adaptor.css';
// 导入光学数据处理工具
import { 
  setupEnterKeyNavigation,
  setupOpticalDataObserver
} from '@/utils/opticalDataUtil';

const router = useRouter();
const activeTab = ref('regular'); // 当前活动选项卡: regular-超主点订单, fuxiangsan-赋像散订单, bulk-批量订单
const selectedStatus = ref('');
const selectedDate = ref(null);

// 使用移动端检测钩子替换原来的isMobile计算属性
const { isMobile } = useMobileDetection(768);

// 超主点订单数据
const allOrders = ref([]);
const currentPage = ref(1);
const pageSize = ref(10);
const totalItems = ref(0);

// 赋像散订单数据
const allFuxiangsanOrders = ref([]);
const fuxiangsanCurrentPage = ref(1);
const fuxiangsanPageSize = ref(10);
const fuxiangsanTotalItems = ref(0);

// 批量订单数据
const allBulkOrders = ref([]);
const bulkCurrentPage = ref(1);
const bulkPageSize = ref(10);
const bulkTotalItems = ref(0);

// 订单过滤
const selectedPatientName = ref('');
const selectedCompany = ref('');
const selectedLensModel = ref('');


// 选中的行数据
const selectedRegularOrderRows = ref([]);
const selectedFuxiangsanOrderRows = ref([]);
const selectedBulkOrderRows = ref([]);

const filteredOrders = computed(() => {
  // 确保 allOrders.value 是一个数组
  if (!Array.isArray(allOrders.value)) {
    return [];
  }

  return [...allOrders.value];
});

// 赋像散订单过滤
const filteredFuxiangsanOrders = computed(() => {
  // 确保 allFuxiangsanOrders.value 是一个数组
  if (!Array.isArray(allFuxiangsanOrders.value)) {
    return [];
  }

  return [...allFuxiangsanOrders.value];
});

// 批量订单过滤
const filteredBulkOrders = computed(() => {
  // 确保 allBulkOrders.value 是一个数组
  if (!Array.isArray(allBulkOrders.value)) {
    return [];
  }

  return [...allBulkOrders.value];
});

// 选项卡切换处理
const handleTabChange = (tab) => {
  if (tab.props.name === 'regular') {
    fetchOrders();
  } else if (tab.props.name === 'fuxiangsanOrder') {
    fetchFuxiangsanOrders();
  } else if (tab.props.name === 'bulk') {
    fetchBulkOrders();
  }
};

// 超主点订单分页处理
const handleRegularCurrentChange = (val) => {
  currentPage.value = val;
  fetchOrders();
};

// 超主点订单每页显示数量变化
const handleRegularSizeChange = (val) => {
  pageSize.value = val;
  currentPage.value = 1;
  fetchOrders();
};

// 赋像散订单分页处理
const handleFuxiangsanCurrentChange = (val) => {
  fuxiangsanCurrentPage.value = val;
  fetchFuxiangsanOrders();
};

// 赋像散订单每页显示数量变化
const handleFuxiangsanSizeChange = (val) => {
  fuxiangsanPageSize.value = val;
  fuxiangsanCurrentPage.value = 1;
  fetchFuxiangsanOrders();
};

// 批量订单分页处理
const handleBulkCurrentChange = (val) => {
  bulkCurrentPage.value = val;
  fetchBulkOrders();
};

// 批量订单每页显示数量变化
const handleBulkSizeChange = (val) => {
  bulkPageSize.value = val;
  bulkCurrentPage.value = 1;
  fetchBulkOrders();
};

const fetchOrders = async () => {
  try {
    const params = {
      pageNum: currentPage.value,
      pageSize: pageSize.value
    };

    // 添加过滤参数（仅当有值时才添加）
    if (selectedStatus.value) params.status = selectedStatus.value;
    
    // 处理日期范围
    if (selectedDate.value && selectedDate.value.length === 2) {
      params.startDate = selectedDate.value[0];
      params.endDate = selectedDate.value[1];
    }
    
    if (selectedPatientName.value) params.patientName = selectedPatientName.value;
    if (selectedCompany.value) params.company = selectedCompany.value;
    if (selectedLensModel.value) params.lensModel = selectedLensModel.value;

    const response = await axios.get('/api/v1/admin/order', {
      params,
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
    if (response.data.code === '200') {
      // 确保将返回的数据正确赋值
      allOrders.value = response.data.data || [];
      totalItems.value = response.data.totalRecords || 0;
      currentPage.value = response.data.pageNum || 1;
      pageSize.value = response.data.pageSize || 10;
      console.log('获取订单列表成功:', response.data);
      
      // 初始化选中状态
      initOrdersSelectedState();
    } else {
      ElMessage.error(response.data.info || '获取订单列表失败');
    }
  } catch (error) {
    console.error('获取订单列表失败:', error);
    if (error.response && error.response.status === 401) {
      return;
    } else {
      ElMessage.error('获取订单列表失败，请检查网络连接');
    }
  }
};

const fetchFuxiangsanOrders = async () => {
  try {
    const params = {
      pageNum: fuxiangsanCurrentPage.value,
      pageSize: fuxiangsanPageSize.value,
      orderType: 'fuxiangsan' // 添加订单类型过滤
    };

    // 添加过滤参数（仅当有值时才添加）
    if (selectedStatus.value) params.status = selectedStatus.value;
    
    // 处理日期范围
    if (selectedDate.value && selectedDate.value.length === 2) {
      params.startDate = selectedDate.value[0];
      params.endDate = selectedDate.value[1];
    }

    if (selectedPatientName.value) params.patientName = selectedPatientName.value;
    if (selectedCompany.value) params.company = selectedCompany.value;
    if (selectedLensModel.value) params.lensModel = selectedLensModel.value;

    const response = await axios.get('/api/v1/admin/scatterorder', {
      params,
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
    if (response.data.code === '200') {
      // 确保将返回的数据正确赋值
      allFuxiangsanOrders.value = response.data.data || [];
      fuxiangsanTotalItems.value = response.data.totalRecords || 0;
      fuxiangsanCurrentPage.value = response.data.pageNum || 1;
      fuxiangsanPageSize.value = response.data.pageSize || 10;
      console.log('获取赋像散订单列表成功:', response.data);
      
      // 初始化选中状态
      initOrdersSelectedState();
    } else {
      ElMessage.error(response.data.info || '获取赋像散订单列表失败');
    }
  } catch (error) {
    console.error('获取赋像散订单列表失败:', error);
    if (error.response && error.response.status === 401) {
      return;
    } else {
      ElMessage.error('获取赋像散订单列表失败，请检查网络连接');
    }
  }
};

const fetchBulkOrders = async () => {
  try {
    const params = {
      pageNum: bulkCurrentPage.value,
      pageSize: bulkPageSize.value
    };

    // 添加过滤参数（仅当有值时才添加）
    if (selectedStatus.value) params.status = selectedStatus.value;
    
    // 处理日期范围
    if (selectedDate.value && selectedDate.value.length === 2) {
      params.startDate = selectedDate.value[0];
      params.endDate = selectedDate.value[1];
    }

    if (selectedCompany.value) params.company = selectedCompany.value;
    if (selectedLensModel.value) params.lensModel = selectedLensModel.value;

    const response = await axios.get('/api/v1/admin/bulkorder', {
      params,
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
    if (response.data.code === '200') {
      // 确保将返回的数据正确赋值
      allBulkOrders.value = response.data.data || [];
      bulkTotalItems.value = response.data.totalRecords || 0;
      bulkCurrentPage.value = response.data.pageNum || 1;
      bulkPageSize.value = response.data.pageSize || 10;
      console.log('获取批量订单列表成功:', response.data);
      
      // 初始化选中状态
      initOrdersSelectedState();
    } else {
      ElMessage.error(response.data.info || '获取批量订单列表失败');
    }
  } catch (error) {
    console.error('获取批量订单列表失败:', error);
    if (error.response && error.response.status === 401) {
      return;
    } else {
      ElMessage.error('获取批量订单列表失败，请检查网络连接');
    }
  }
};

const getStatusType = (status) => {
  switch (status) {
    case 'Exported': return 'success';
    case 'Noexported': return 'warning';
    default: return 'info';
  }
};

const getStatusText = (status) => {
  switch (status) {
    case 'Exported': return '已导出';
    case 'Noexported': return '未导出';
    default: return status;
  }
};

// 修改handleEdit函数
const handleEdit = async (row) => {
  try {
    // 计算行的序号（用于组件内部显示）
    const orderIndex = filteredOrders.value.findIndex(item => item.id === row.id);
    // 添加分页和索引信息
    const rowWithPagination = {
      ...row,
      index: orderIndex,
      currentPage: currentPage.value,
      pageSize: pageSize.value
    };
    
    // 调用组件的方法
    const orderEditComponentInstance = orderEditComponentRef.value;
    if (orderEditComponentInstance) {
      await orderEditComponentInstance.handleEdit(rowWithPagination);
    }
  } catch (error) {
    console.error('编辑失败:', error);
    ElMessage.error('编辑操作出错');
  }
};

const handleDelete = async (row) => {
  try {
    await ElMessageBox.confirm('确认删除该订单吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });

    const response = await axios.delete(`/api/v1/admin/order?Id=${row.id}`);
    if (response.data.code === '200') {
      ElMessage.success('删除成功');
      fetchOrders();
    } else {
      ElMessage.error(response.data.info);
    }
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败');
    }
  }
};

const handleExportExcel = async () => {
  orderEditComponentRef.value.handleExportExcel();
};

// 全局检索：一次性查询三张表
const handleSearch = () => {
  // 将各分页的页码复位，保证后续查询从第一页开始
  currentPage.value = 1;
  fuxiangsanCurrentPage.value = 1;
  bulkCurrentPage.value = 1;

  if (activeTab.value === 'regular') {
    fetchOrders();
  } else if (activeTab.value === 'fuxiangsanOrder') {
    fetchFuxiangsanOrders();
  } else if (activeTab.value === 'bulk') {
    fetchBulkOrders();
  }
};

const resetSearch = () => {
  selectedStatus.value = '';
  selectedDate.value = null;
  // 重置所有筛选条件
  selectedPatientName.value = '';
  selectedCompany.value = '';
  selectedLensModel.value = '';

  // 所有列表回到第一页并重新拉取数据
  currentPage.value = 1;
  fuxiangsanCurrentPage.value = 1;
  bulkCurrentPage.value = 1;

  fetchOrders();
  fetchFuxiangsanOrders();
  fetchBulkOrders();
};

// 批量订单导出Excel
const handleExportBulkExcel = async () => {
  bulkOrderEditComponentRef.value.handleExportBulkExcel();
};

// 修改handleEditBulk函数
const handleEditBulk = async (row) => {
  try {
    // 计算行的序号（用于组件内部显示）
    const orderIndex = filteredBulkOrders.value.findIndex(item => item.id === row.id);
    // 添加分页和索引信息
    const rowWithPagination = {
      ...row,
      index: orderIndex,
      currentPage: bulkCurrentPage.value,
      pageSize: bulkPageSize.value
    };
    
    // 调用组件的方法
    const bulkOrderEditComponentInstance = bulkOrderEditComponentRef.value;
    if (bulkOrderEditComponentInstance) {
      await bulkOrderEditComponentInstance.handleEditBulk(rowWithPagination);
    }
  } catch (error) {
    console.error('编辑失败:', error);
    ElMessage.error('编辑操作出错');
  }
};

// 删除批量订单
const handleDeleteBulk = async (row) => {
  try {
    await ElMessageBox.confirm('确认删除该批量订单吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });

    const response = await axios.delete(`/api/v1/admin/bulkorder?Id=${row.id}`);
    if (response.data.code === '200') {
      ElMessage.success('删除成功');
      fetchBulkOrders();
    } else {
      ElMessage.error(response.data.info);
    }
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败');
    }
  }
};

// 更新样式
const style = document.createElement('style');
style.textContent = `
.edit-order-dialog {
  width: 1400px !important;
  max-width: 95vw !important;
  box-sizing: border-box;
}

.edit-order-dialog .el-message-box__content {
  padding: 20px;
  max-height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.edit-order-form .form-section {
  margin-bottom: 25px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
}

.edit-order-form .form-section h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
  color: #303133;
  font-size: 16px;
  font-weight: bold;
}

.edit-order-form .beta-history-section {
  padding: 20px 24px 24px;
  border: 1px solid #dce9f5;
  border-radius: 8px;
  background: #f8fbff;
  box-shadow: 0 3px 10px rgba(64, 158, 255, 0.08);
}

.edit-order-form .beta-history-section h3 {
  color: #24557d;
  border-bottom-color: #cfe0ef;
}

.edit-order-form .beta-history-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.edit-order-form .beta-history-item {
  min-width: 0;
  padding: 16px 18px;
  border: 1px solid #dfe8f1;
  border-left: 3px solid #409eff;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(31, 78, 121, 0.05);
}

.edit-order-form .beta-history-label {
  color: #303133;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
}

.edit-order-form .beta-history-radio {
  display: flex;
  gap: 24px;
  margin-top: 12px;
}

.edit-order-form .beta-history-radio label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
}

.edit-order-form .beta-history-radio input[type="radio"] {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: #409eff;
}

.edit-order-form .beta-history-duration {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  min-width: 0;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed #dfe8f1;
}

.edit-order-form .beta-history-sublabel {
  width: auto;
  padding: 0;
  color: #606266;
  font-size: 13px;
  text-align: right;
  white-space: nowrap;
}

.edit-order-form .beta-duration-control {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.edit-order-form .beta-duration-control .el-input__inner {
  flex: 0 0 88px;
  width: 88px;
  min-width: 88px;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background-color: #fff;
  padding-left: 12px;
  padding-right: 28px;
  text-align: left;
}

.edit-order-form .beta-duration-unit {
  color: #606266;
  font-size: 13px;
  white-space: nowrap;
}

.edit-order-form .beta-history-elapsed {
  flex-basis: 100%;
  color: #409eff;
  font-size: 12px;
  line-height: 1.4;
}

.edit-order-form .form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.edit-order-form .form-row.compact {
  gap: 8px;
  margin-bottom: 10px;
}

.edit-order-form .form-item {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
}

.edit-order-form .form-item.full-width {
  flex: 1 1 100%;
}

.edit-order-form .form-item label {
  width: 70px;
  text-align: right;
  padding-right: 8px;
  color: #606266;
  white-space: nowrap;
  font-size: 14px;
}

.edit-order-form .form-item .el-input__inner {
  flex: 1;
  height: 32px;
  line-height: 32px;
  padding: 0 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background-color: #fff;
  min-width: 80px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edit-order-form .form-item .el-input__inner[readonly] {
  background-color: #f5f7fa;
  cursor: not-allowed;
}

.edit-order-form .form-item .el-textarea__inner {
  flex: 1;
  height: 60px;
  padding: 5px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background-color: #fff;
  resize: none;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}

.edit-order-form .two-columns {
  display: flex;
  gap: 20px;
}

.edit-order-form .two-columns .column {
  flex: 1;
  min-width: 0;
}

.edit-order-form .cycloplegic-refraction-column {
  order: 1;
}

.edit-order-form .regular-refraction-column {
  order: 2;
}

.edit-order-form .trial-refraction-column {
  order: 3;
}

@media screen and (max-width: 1200px) {
  .edit-order-form .two-columns {
    flex-wrap: wrap;
  }

  .edit-order-form .two-columns .column {
    flex: 1 1 calc(50% - 10px);
    min-width: 360px;
  }

  .edit-order-form .basic-info .form-row {
    flex-wrap: wrap;
  }

  .edit-order-form .basic-info .form-item {
    flex: 1 1 calc(50% - 10px);
    min-width: 240px;
  }
}

.edit-order-form .eye-data-container {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.edit-order-form .eye-section {
  flex: 1;
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 12px;
}

.edit-order-form .eye-section h4 {
  margin: 0 0 8px 0;
  color: #606266;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid #EBEEF5;
  padding-bottom: 6px;
}

.edit-order-form .eye-section .form-row {
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.edit-order-form .eye-section .form-row:last-child {
  margin-bottom: 0;
}

.edit-order-form .form-item select.el-input__inner {
  padding-right: 24px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23606266'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  appearance: none;
}

.edit-order-form .delivery-info .form-item .el-input__inner {
  min-width: 160px;
}

.edit-order-form .delivery-info .form-item .el-textarea__inner {
  min-height: 60px;
}

/* 优化标题和内容的间距 */
.edit-order-form .form-section > h3 {
  margin-bottom: 12px;
}

/* 优化表单项的垂直对齐 */
.edit-order-form .form-item {
  margin-bottom: 8px;
}

/* 确保所有输入框宽度合适 */
.edit-order-form .form-item .el-input__inner,
.edit-order-form .form-item .el-textarea__inner {
  width: 100%;
  box-sizing: border-box;
}
/* 针对小屏幕优化对话框内表单布局 */
@media screen and (max-width: 768px) {
  .edit-order-dialog {
    width: 98% !important;
    max-width: 95vw !important;
  }

  .edit-order-dialog .el-message-box__content {
    padding: 10;
  }

  .edit-order-form .form-section {
    padding: 10px;
    margin: 0 auto;
    max-width: 90%;
  }

  .edit-order-form .form-row {
    flex-direction: column;
    gap: 8px;
  }

  .edit-order-form .form-item {
    width: 100%;
  }

  .edit-order-form .form-item label {
    width: 60px;
    font-size: 12px;
  }

  .edit-order-form .form-item .el-input__inner,
  .edit-order-form .form-item .el-textarea__inner {
    width: 100%;
    min-width: 0;
    font-size: 12px;
  }

  .edit-order-form .beta-history-section {
    padding: 16px;
    max-width: none;
  }

  .edit-order-form .beta-history-grid {
    grid-template-columns: 1fr;
  }

  .edit-order-form .beta-history-item {
    padding: 14px;
  }

  .edit-order-form .beta-history-duration {
    grid-template-columns: 76px minmax(0, 1fr);
  }

  .edit-order-form .beta-duration-control .el-input__inner {
    flex: 1 1 88px;
    width: auto;
    min-width: 72px;
  }

  .edit-order-form .two-columns {
    flex-direction: column;
    gap: 10px;
  }

  .edit-order-form .eye-data-container {
    flex-direction: column;
    gap: 10px;
  }

  .edit-order-form .eye-section {
    padding: 8px;
  }

  .edit-order-form .eye-section h4 {
    font-size: 13px;
  }
  .el-message-box__container {
    display: block !important; /* 覆盖 Element UI 的 flex 设置 */
  }
}
`;
document.head.appendChild(style);

onMounted(() => {
  fetchOrders();
  if (activeTab.value === 'fuxiangsan') {
    fetchFuxiangsanOrders();
  } else if (activeTab.value === 'bulk') {
    fetchBulkOrders();
  }
  setupEnterKeyNavigation();
  // 设置DOM观察器来处理验光数据输入和计算
  setupOpticalDataObserver();
  
  // 添加日期选择器移动端样式
  const datepickerStyle = document.createElement('style');
  datepickerStyle.textContent = `
    /* 移动端日期选择器面板适配 */
    @media screen and (max-width: 768px) {
      .el-picker-panel {
        max-width: 90vw !important;
        width: 90vw !important;
        min-width: 0 !important;
      }
      
      .el-date-picker {
        width: 90vw !important;
      }
      
      .el-date-range-picker__content {
        padding: 5px !important;
      }
      
      .el-date-range-picker__header {
        margin-bottom: 5px !important;
        height: 30px !important;
        line-height: 30px !important;
      }
      
      .el-date-range-picker__header div {
        margin-right: 0 !important;
        padding-left: 0 !important;
      }
      
      .el-date-range-picker__header button {
        padding: 0 5px !important;
      }
      
      .el-picker-panel__icon-btn {
        margin: 0 2px !important;
        width: 20px !important;
        height: 20px !important;
      }
      
      .el-date-table {
        font-size: 12px !important;
      }
      
      .el-date-table td {
        padding: 0 !important;
        height: 28px !important;
      }
      
      .el-date-table td div {
        height: 28px !important;
        line-height: 28px !important;
        padding: 0 !important;
      }
      
      .el-date-range-picker__content.is-left,
      .el-date-range-picker__content.is-right {
        width: 50% !important;
        min-width: 0 !important;
      }
      
      .el-date-range-picker__time-header {
        padding: 5px !important;
      }
      
      .el-date-table th {
        padding: 5px 0 !important;
      }
    }
    
    /* 超小屏幕（<600px）日期选择器上下布局 */
    @media screen and (max-width: 600px) {
      /* 调整日期范围选择器布局为上下结构 */
      .el-date-range-picker {
        width: 90vw !important;
        min-width: 0 !important;
      }
      
      .el-date-range-picker .el-picker-panel__body {
        min-width: 0 !important;
        width: 100% !important;
      }
      
      .el-date-range-picker .el-picker-panel__body-wrapper {
        flex-direction: column !important;
      }
      
      .el-date-range-picker__content.is-left,
      .el-date-range-picker__content.is-right {
        width: 100% !important;
        float: none !important;
        border-right: none !important;
        border-left: none !important;
      }
      
      .el-date-range-picker__content.is-right {
        border-top: 1px solid #e4e4e4 !important;
        padding-top: 10px !important;
        margin-top: 5px !important;
      }
      
      .el-date-range-picker__header {
        margin-bottom: 3px !important;
      }
      
      /* 减小日期表格大小 */
      .el-date-table td {
        height: 24px !important;
      }
      
      .el-date-table td div {
        height: 24px !important;
        line-height: 24px !important;
      }
      
      /* 调整底部按钮区域 */
      .el-picker-panel__footer {
        padding: 5px !important;
      }
      
      .el-picker-panel__footer .el-button {
        padding: 5px 10px !important;
        font-size: 12px !important;
      }
    }
  `;
  document.head.appendChild(datepickerStyle);
});

// 处理选择变化
const handleRegularSelectionChange = (val) => {
  selectedRegularOrderRows.value = val;
};

const handleBulkSelectionChange = (val) => {
  selectedBulkOrderRows.value = val;
};

// 导出选中的超主点订单
const handleExportSelectedOrders = async () => {
  if (selectedRegularOrderRows.value.length === 0) {
    ElMessage.warning('请至少选择一条订单');
    return;
  }
  orderEditComponentRef.value.handleExportSelectedOrders(selectedRegularOrderRows.value);
};

// 导出选中的批量订单
const handleExportSelectedBulkOrders = async () => {
  if (selectedBulkOrderRows.value.length === 0) {
    ElMessage.warning('请至少选择一条批量订单');
    return;
  }
  bulkOrderEditComponentRef.value.handleExportSelectedBulkOrders(selectedBulkOrderRows.value);
};

// 处理赋像散订单选择变化
const handleFuxiangsanSelectionChange = (val) => {
  selectedFuxiangsanOrderRows.value = val;
};

// 修改handleEditFuxiangsan函数
const handleEditFuxiangsan = async (row) => {
  try {
    // 计算行的序号（用于组件内部显示）
    const orderIndex = filteredFuxiangsanOrders.value.findIndex(item => item.id === row.id);
    // 添加分页和索引信息
    const rowWithPagination = {
      ...row,
      index: orderIndex,
      currentPage: fuxiangsanCurrentPage.value,
      pageSize: fuxiangsanPageSize.value
    };
    
    // 调用组件的方法
    const fuxiangsanOrderEditComponentInstance = fuxiangsanOrderEditComponentRef.value;
    if (fuxiangsanOrderEditComponentInstance) {
      await fuxiangsanOrderEditComponentInstance.handleEditFuxiangsan(rowWithPagination);
    }
  } catch (error) {
    console.error('编辑失败:', error);
    ElMessage.error('编辑操作出错');
  }
};

// 删除赋像散订单
const handleDeleteFuxiangsan = async (row) => {
  try {
    await ElMessageBox.confirm('确认删除该赋像散订单吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });

    const response = await axios.delete(`/api/v1/admin/scatterorder?Id=${row.id}`);
    if (response.data.code === '200') {
      ElMessage.success('删除成功');
      fetchFuxiangsanOrders();
    } else {
      ElMessage.error(response.data.info);
    }
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败');
    }
  }
};

// 导出赋像散订单Excel
const handleExportFuxiangsanExcel = async () => {
  fuxiangsanOrderEditComponentRef.value.handleExportFuxiangsanExcel();
};

// 导出选中的赋像散订单
const handleExportSelectedFuxiangsanOrders = async () => {
  if (selectedFuxiangsanOrderRows.value.length === 0) {
    ElMessage.warning('请至少选择一条赋像散订单');
    return;
  }
  fuxiangsanOrderEditComponentRef.value.handleExportSelectedFuxiangsanOrders(selectedFuxiangsanOrderRows.value);
};

// 添加订单详情查看功能
const showOrderDetails = (row) => {
  orderEditComponentRef.value.showOrderDetails(row);
};

const showFuxiangsanOrderDetails = (row) => {
  fuxiangsanOrderEditComponentRef.value.showFuxiangsanOrderDetails(row);
};

const showBulkOrderDetails = (row) => {
  bulkOrderEditComponentRef.value.showBulkOrderDetails(row);
};

// 处理单个项目的选中状态变化
const handleItemSelect = (item, type, selected) => {
  // 根据类型获取对应的选中数组
  let selectedItems;

  if (type === 'regular') {
    selectedItems = selectedRegularOrderRows;
  } else if (type === 'fuxiangsan') {
    selectedItems = selectedFuxiangsanOrderRows;
  } else if (type === 'bulk') {
    selectedItems = selectedBulkOrderRows;
  }

  // 更新本条 item 的选中状态
  item.selected = selected;

  if (selected) {
    // 选中：若不在数组中则添加
    if (!selectedItems.value.some(sel => sel.id === item.id)) {
      selectedItems.value.push(item);
    }
  } else {
    // 取消：从数组中移除
    selectedItems.value = selectedItems.value.filter(sel => sel.id !== item.id);
  }
};

// 初始化订单的选中状态
const initOrdersSelectedState = () => {
  // 为超主点订单设置选中状态
  allOrders.value.forEach(item => {
    item.selected = selectedRegularOrderRows.value.some(selected => selected.id === item.id);
  });

  // 为赋像散订单设置选中状态
  allFuxiangsanOrders.value.forEach(item => {
    item.selected = selectedFuxiangsanOrderRows.value.some(selected => selected.id === item.id);
  });

  // 为批量订单设置选中状态
  allBulkOrders.value.forEach(item => {
    item.selected = selectedBulkOrderRows.value.some(selected => selected.id === item.id);
  });
};

// 添加组件引用
const orderEditComponentRef = ref(null);
const bulkOrderEditComponentRef = ref(null);
const fuxiangsanOrderEditComponentRef = ref(null);

// 添加处理物流查询的函数
const checkTracking = (row) => {
  if (!row.trackingNumber) {
    ElMessage.warning('该订单没有物流编号');
    return;
  }
  
  // 提取手机号后四位
  let phoneLastFour = '';
  if (row.phone && row.phone.length >= 4) {
    phoneLastFour = row.phone.slice(-4);
  }
  
  // 跳转到物流查询页面并传递参数
  router.push({
    path: '/mail',
    query: {
      trackingNumber: row.trackingNumber,
      phoneNumber: phoneLastFour
    }
  });
};
</script>
